var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var gql = String.raw;
var entityOpenGraphFields = function (thumbnailSizes, descriptionFields) {
  if (descriptionFields === void 0) {
    descriptionFields = ['text'];
  }
  return gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      openGraph { \n        id title \n        ", "\n        image { \n          id url url2x ", "\n        } \n      }\n    "], ["\n      openGraph { \n        id title \n        ", "\n        image { \n          id url url2x ", "\n        } \n      }\n    "])), !!descriptionFields.length ? gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["description { ", " }"], ["description { ", " }"])), descriptionFields.join(' ')) : '', !!thumbnailSizes.length && gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          thumbnails { \n            id ", "\n          }\n          "], ["\n          thumbnails { \n            id ", "\n          }\n          "])), thumbnailSizes.map(function (size) {
    return gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", " { id url url2x }"], ["", " { id url url2x }"])), size);
  }).join('\n')));
};
export var EntityOpenGraphFields = entityOpenGraphFields([]);
export var EntityOpenGraphFieldsSmall = entityOpenGraphFields(['small']);
export var EntityOpenGraphFieldsMedium = entityOpenGraphFields(['medium']);
export var EntityOpenGraphFieldsLarge = entityOpenGraphFields(['large']);
export var EntityOpenGraphFieldsCard = entityOpenGraphFields(['card']);
export var EntityOpenGraphFieldsBubble = entityOpenGraphFields(['bubble']);
export var EntityOpenGraphFieldsBubbleMedium = entityOpenGraphFields(['bubbleMedium'], []);
export var EntityOpenGraphFieldsBubbleLarge = entityOpenGraphFields(['bubbleLarge']);
export var EntityOpenGraphFieldsMainBanner = entityOpenGraphFields(['mainBanner']);
export var EntityOpenGraphFieldsHalfBanner = entityOpenGraphFields(['halfBanner']);
export var EntityOpenGraphFieldsSelect = entityOpenGraphFields(['small']);
// for details, we pull the plain text too, as it is used for the openGraph tags in the page
export var EntityOpenGraphFieldsDetails = entityOpenGraphFields(['bubbleLarge', 'mainBanner', 'halfBanner'], ['plain', 'text']);
export var EntityOpenGraphFieldsList = entityOpenGraphFields(['bubble', 'card'], []);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;